import { render } from "./ConfigManagerDialog.vue?vue&type=template&id=22d032f5&scoped=true"
import script from "./ConfigManagerDialog.vue?vue&type=script&lang=js"
export * from "./ConfigManagerDialog.vue?vue&type=script&lang=js"

import "./ConfigManagerDialog.vue?vue&type=style&index=0&id=22d032f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_@vue+compiler-sfc@3.3.11_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d032f5"]])

export default __exports__